var orderList = [
    {
        //'id': '577dd77be5bc150720992728',
        'id': '',
        'name': 'Alpha Base Station',
        'pro': 'Strong signal coverage with a centrally managed platform, designed for outdoor installations',
        'proImg':'/static/image/order/base_station@1x.png',
        'proImg1':'/static/image/order/base_station@2x.png',
        // 'enprice': '',
        // 'specEnprice': 0,
        'contactMes':'Contact sales',
        'curNum': 0,
        'shopTotal':'',
        'linkTo':'/en/Alpha#AlphaBaseStation'
    },
    {
        'id': '',
        'name': 'Alpha Gateway',
        'pro': 'Built for indoor IoT scenarios where require devices with low-power consumption, long-range communication and low throughput',
        'proImg':'/static/image/order/Alpha_Gateway@1x.png',
        'proImg1':'/static/image/order/Alpha_Gateway@2x.png',
        // 'enprice': 0,
        // 'specEnprice': 0,
        'contactMes':'Contact sales',
        'curNum': 0,
        'shopTotal':'',
        'linkTo':'/en/Alpha#AlphaGateway'
    },
    {
        'id': '',
        'name': 'Alpha 11x11mm Chipset',
        'pro': 'LPWAN Dual-Module Chip enables possible sizes of various sensors communicating via BLE and long-range IoT network',
        'proImg':'/static/image/order/Alpha_Chipset@1x.png',
        'proImg1':'/static/image/order/Alpha_Chipset@2x.png',
        // 'enprice': 0,
        // 'specEnprice': 0,
        'contactMes':'Contact sales',
        'curNum': 0,
        'shopTotal':'',
        'linkTo':'/en/Alpha#AlphaModule'
    },
    {
        'id': '',
        'name': 'Environmental Monitoring Suite',
        'pro': 'All the sensor data upload to the Alpha commander cloud platform through Alpha base station automatically.',
        'proImg':'/static/image/order/Environmental_Monitoring_Suite@1x.png',
        'proImg1':'/static/image/order/Environmental_Monitoring_Suite@2x.png',
        // 'enprice': 0,
        // 'specEnprice': 0,
        'contactMes':'Contact sales',
        'curNum': 0,
        'shopTotal':'',
        'linkTo':'/en/Alpha'
    },
    // {
    //     'id': '',
    //     'name': 'Indoor Navigation Suite',
    //     'pro': 'Node 4AA works as a BLE beacon and supports multiple near-field transmission protocols in the proximity use case',
    //     'proImg':'/static/image/order/Indoor_Navigation_Suite@1x.png',
    //     'proImg1':'/static/image/order/Indoor_Navigation_Suite@2x.png',
    //     // 'enprice': 0,
    //     // 'specEnprice': 0,
    //     'contactMes':'Contact sales',
    //     'curNum': 0,
    //     'shopTotal':'',
    //     'linkTo':'/en/Alpha#AlphaNode4AA'
    // },
/*    {
        'id': '577dd736e5bc150720992727',
        'name': 'Alpha Node-4AA',
        'pro': 'IoT low-power temperature and humidity sensor, supports both BLE and long-range communication',
        'proImg':'/static/image/order/Alpha_Node@1x.png',
        'proImg1':'/static/image/order/Alpha_Node@2x.png',
        'enprice': 0,
        'specEnprice': 0,
        'curNum': 0,
        'shopTotal':'',
        'linkTo':'/en/Alpha#AlphaNode4AA'
    },*/
/*    {
        'id': '54d349e4e72cf5b331791ec5',
        'name': 'Yunzi',
        'pro': 'Energy efficient, including multiple sensors with optimized performance and design',
        'proImg':'/static/image/order/Yunzi@1x.png',
        'proImg1':'/static/image/order/Yunzi@2x.png',
        'enprice': 0,
        'specEnprice': 0,
        'curNum': 0,
        'shopTotal':'',
        'linkTo':'/en/Beacons#Yunzi'
    },*/
    // {   'id': '548ae7c985475d7f0b607913',
    //     'name': 'SmartBeacon-USB',
    //     'pro': 'Both energy efficient and aesthetic, functions as a beacon while connected to a USB port.',
    //     'proImg':'/static/image/order/SmartBeacon-USB@1x.png',
    //     'proImg1':'/static/image/order/SmartBeacon-USB@2x.png',
    //     'enprice': 0,
    //     'specEnprice': 0,
    //     'curNum': 0,
    //     'shopTotal':'',
    //     'linkTo':'/en/Beacons#SmartBeaconUSB'
    // },
    // {
    //     'id': '548ae7e185475d7f0b607915',
    //     'name': 'SmartBeacon-4AA',
    //     'pro': 'For commecial deployment with ultra-low power consumption.',
    //     'proImg':'/static/image/order/SmartBeacon-4AA@1x.png',
    //     'proImg1':'/static/image/order/SmartBeacon-4AA@2x.png',
    //     'enprice': 0,
    //     'specEnprice': 0,
    //     'curNum': 0,
    //     'shopTotal':'',
    //     'linkTo':'/en/Beacons#SmartBeacon4AA'
    // }
    
/*     {
        'id': '563322b4a8357c4a62f14380',
        'name': 'SmartBeacon-4AA Pro',
        'pro': '★ Professional deployment accessories for 4AA Pro (water proof IP67): wall-mount, screws & screwdriver are included.',
        'proImg':'/static/image/order/SmartBeacon@1x.png',
        'proImg1':'/static/image/order/SmartBeacon@2x.png',
        'enprice': 0,
        'specEnprice': 0,
        'curNum': 0,
        'shopTotal':'',
        'linkTo':'/en/Beacons#SmartBeacon4AAPro'
    }, */
    // {
    //     'id': '5b96386331caaebb50e01336',
    //     'name': 'Beacons Test Suite',
    //     'pro': 'All the kinds of beacons from SENSORO',
    //     'proImg':'/static/image/order/Beacons_Test_Suite@1x.png',
    //     'proImg1':'/static/image/order/Beacons_Test_Suite@2x.png',
    //     'enprice': 0,
    //     'specEnprice': 0,
    //     'curNum': 0,
    //     'shopTotal':'',
    //     'linkTo':'/en/Beacons'
    // },
    // {
    //     'id': '5d12092db4c3ca5343d7c082',
    //     'name': 'Beacons Test Suite',
    //     'pro': 'All the kinds of beacons from SENSORO',
    //     'proImg':'/static/image/order/Beacons_Suite@1x.png',
    //     'proImg1':'/static/image/order/Beacons_Suite@2x.png',
    //     'enprice': 0,
    //     'specEnprice': 0,
    //     'curNum': 0,
    //     'shopTotal':'',
    //     'linkTo':'/en/Beacons'
    // }
]
module.exports={
    orderList:orderList
}



// WEBPACK FOOTER //
// ./src/assets/js/orderList.js